<ion-button
  [expand]="expand()"
  [type]="type()"
  [disabled]="disabled() || loading()"
  [fill]="fill()"
  [color]="color()"
  [size]="size()"
  [class]="variant() + ' ' + cssClass()"
>
  @if (loading()) {
    <ion-spinner name="crescent"></ion-spinner>
    <span>{{ loadingText() || label() }}</span>
  } @else {
    <span>{{ label() }}</span>
  }
</ion-button>
